import { registerPlugin, PluginListenerHandle } from '@capacitor/core'

interface DynamicTypePlugin {
  getScale(): Promise<{ scale: number }>
  addListener(eventName: 'change', listener: (data: { scale: number }) => void): Promise<PluginListenerHandle>
}

export const DynamicType = registerPlugin<DynamicTypePlugin>('DynamicType')
